export class RequestHandler {
  applicationType: 'standalone' | 'local' | 'fox' = 'standalone';

  assetPathPrefix: string;

  language = 'en';

  country = 'us';

  location: Location;

  constructor() {
    this.assetPathPrefix = '';
    this.location = window.location;
    const { hostname, pathname } = window.location;
    if (hostname.includes('localhost')) {
      this.applicationType = 'local';
    } else if (pathname.includes('eac')) {
      this.applicationType = 'standalone';
    } else if (hostname.includes('festo.com')) {
      this.applicationType = 'fox';
    }

    this.extractLocaleFromQuery();
    if (this.applicationType === 'fox') {
      this.assetPathPrefix = `/eac/${this.language}_${this.country}${
        process.env.REACT_APP_PATH_PREFIX !== undefined ? process.env.REACT_APP_PATH_PREFIX : ''
      }/`;
    }
  }

  normalizeAssetPath = (assetPath: string): string => `${this.assetPathPrefix}${assetPath}`;

  private extractLocaleFromQuery(): void {
    switch (this.applicationType) {
      case 'fox': {
        const pathItems = window.location.pathname.split('/');
        let counter = 0;
        if (pathItems.includes('s') && pathItems.includes('media-resistance')) {
          pathItems.forEach((item: string) => {
            if (item.match(/^[a-z]{2}$/g)) {
              if (counter === 0) {
                this.country = item;
              } else if (counter === 1) {
                this.language = item;
              }
              counter++;
            }
          });
        }
        break;
      }
      case 'standalone':
      default: {
        const { pathname } = this.location;
        if (pathname.includes('eac')) {
          const pathItems = pathname.split('/');
          const referenceIndex = pathItems.indexOf('eac');
          const localeItem = pathItems[referenceIndex + 1];

          if (localeItem.match(/^[a-z]{2}_[a-z]{2}$/g)) {
            [this.language, this.country] = localeItem.split('_');
          } else if (localeItem.match(/^[a-z]{2}-[a-z]{2}_[a-z]{2}$/g)) {
            [this.language, , this.country] = localeItem.split(/[-|_]/g);
          }
        }
        break;
      }
    }
  }
}
